var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import query from 'syf-component-library/const/mediaQueries';
import { Inline, Inset } from 'syf-component-library/ui/spacing';
import useMediaQuery from '../../../../hooks/use-media-query';
import { colors } from '../../../../theme';
import { StyledFlex, StyledText } from '../../../subcomponents';
import { StyledDetail, StyledValue } from './subcomponents';
var Detail = function (_a) {
    var icon = _a.icon, title = _a.title, value = _a.value;
    var isMobile = useMediaQuery(query.lessThanSmall);
    return (_jsxs(_Fragment, { children: [_jsxs(StyledDetail, __assign({ direction: isMobile ? 'column' : 'row', alignItems: !isMobile && 'center', justifyContent: !isMobile && 'space-between' }, { children: [_jsxs(StyledFlex, __assign({ alignItems: "center" }, { children: [_jsx(Inset, __assign({ all: "medium" }, { children: _jsx(FontAwesomeIcon, { icon: icon, size: "1x", color: colors.cyanBlue }) })), _jsx(StyledText, __assign({ align: "left" }, { children: title }))] })), _jsx(StyledValue, { children: _jsxs(StyledText, __assign({ weight: "bold", align: "left" }, { children: [_jsx(Inline, { size: "xlarge" }), value] })) })] })), _jsx(Inset, { bottom: "small", hideOnBreakpointUp: "small" })] }));
};
export default Detail;
//# sourceMappingURL=detail.js.map